import React from 'react';
import { ChooseMethodModal } from '../ChooseMethodModal';
import { ValidateCodeModal } from '../ValidateCodeModal';

const ValidationCodeFlow = ({
  showChooseMethodModal,
  goToValidateStep,
  goToChooseMethodStep,
  currentStep,
  twoFactorIsEnabled,
  toggleValidationCodeFlow,
  validateCodeModal,
  twoFactorAuthLocale,
  userEmail,
  userPhone,
}) => (
  <>
    {currentStep === 'CHOOSE_METHOD' && (
      <ChooseMethodModal
        isOpen={showChooseMethodModal}
        goToValidateStep={goToValidateStep}
        twoFactorIsEnabled={twoFactorIsEnabled}
        toggleValidationCodeFlow={toggleValidationCodeFlow}
        twoFactorAuthLocale={twoFactorAuthLocale}
        userEmail={userEmail}
        userPhone={userPhone}
      />
    )}

    {currentStep === 'VALIDATE_CODE' && (
      <ValidateCodeModal
        modal={validateCodeModal}
        toggleValidationCodeFlow={toggleValidationCodeFlow}
        goToChooseMethodStep={goToChooseMethodStep}
        twoFactorIsEnabled={twoFactorIsEnabled}
        twoFactorAuthLocale={twoFactorAuthLocale}
        userEmail={userEmail}
        userPhone={userPhone}
      />
    )}
  </>
);

export default ValidationCodeFlow;
